import Card from 'react-bootstrap/Card';
import { Row, Col, Button } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { Trans } from 'react-i18next';
import { useSelector } from 'react-redux';

function CardBody(school) {

    const styles = {
        //backgroundImage: `linear-gradient(rgba(128, 128, 128, 0.2), rgba(128, 128, 128, 0.2)), url(${school.image})`,
    
        backgroundSize: 'cover',
        backgroundPosition: 'center',

        color: 'white',
        textAlign: 'center',
        marginLeft: '10px',
        marginRight: '10px',
        marginTop: '10px',
        height: 'fit-content',
        
    };
    
    const buttonStyle = {
        color: 'rgba(40, 79, 170, 1)',
        textAlign: 'center',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight:'900'

    }
    
    const textStyle = {
        //textShadow: '1px 1px 1px rgba(0, 0, 0, 0.7)',

        
    };

   
    
    return (
        <Col md={4} sm={6}>
            <Card style={styles}>
                <Card.Body className='card-body d-flex flex-column'>
                    <Card.Img variant="top"src={school.image} style={{objectFit: 'contain',objectPosition: 'top center', height: '200px', itbackgroundColor: 'white',padding: '1rem',}}/>
                    {/* <Card.Title style={{...textStyle, fontWeight: '800'}} className="justify-content-center d-flex"><Trans ns="sateliteSchools" i18nKey={school.name} /></Card.Title> */}
                    <Card.Text className='card-text mt-auto mb-3' style={{...textStyle, ...buttonStyle}}>
                        <Trans ns="sateliteSchools" i18nKey={`${school.name} preview`} />
                    </Card.Text>
                    <Button as={Link} to={`/school/${school.name}`} variant="primary" size="lg" className="btn-sm btn-color-yellow w-50 w-sm-25 mx-auto d-block mb-2 "><Trans i18nKey={"FindOutMoreAboutSchool"} /></Button>
                </Card.Body>
                
            </Card>
        </Col>
    );
}

function MainBlock() {
    const schoolsList = useSelector(state => state.satelliteSchools.schools_list);
    let listOfSchools = () => schoolsList.map((item) => CardBody(item))

    return (
        <>
            <Row className='SateliteSchoolsLayoutBlock'>
                {listOfSchools()}
            </Row>
        </>
    )
}

export default (MainBlock);

